const features = [
  {
    icon: "ri-shield-check-line",
    title: "End-to-End Encryption",
    description:
      "Every app we build puts user data protection first. AES-256 encryption and zero-knowledge architecture are standard in all our security products.",
  },
  {
    icon: "ri-speed-line",
    title: "Performance Optimized",
    description:
      "Our apps are engineered for speed and efficiency — minimal battery drain, small footprint, and instant response times on all supported iOS devices.",
  },
  {
    icon: "ri-user-heart-line",
    title: "Intuitive Design",
    description:
      "We follow Apple's Human Interface Guidelines meticulously, creating apps that feel native, familiar, and genuinely easy to use for anyone.",
  },
  {
    icon: "ri-lock-password-line",
    title: "Privacy by Default",
    description:
      "No user tracking. No data selling. No ads. TIAS OOD products are built on a strict privacy-first philosophy — your data is yours alone.",
  },
  {
    icon: "ri-refresh-line",
    title: "Regular Updates",
    description:
      "We continuously improve our apps with new features and security patches, keeping them compatible with the latest iOS versions and best practices.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Dedicated Support",
    description:
      "Our team is available to assist users whenever they need help — fast, friendly, and knowledgeable support for all TIAS OOD products.",
  },
  {
    icon: "ri-smartphone-line",
    title: "iOS-Native Architecture",
    description:
      "Built from the ground up for iOS using Swift and native frameworks. No cross-platform compromises — just pure, polished Apple platform performance.",
  },
  {
    icon: "ri-global-line",
    title: "Globally Trusted",
    description:
      "Thousands of users across the globe rely on our applications daily for their mobile security and device maintenance needs.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-28 bg-[#111111]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-amber-500 text-xs font-semibold uppercase tracking-widest">Why TIAS OOD</span>
          <h2 className="mt-3 text-4xl lg:text-5xl font-bold text-white leading-tight">
            What Sets Us Apart
          </h2>
          <p className="mt-4 text-white/50 max-w-xl mx-auto text-base">
            From architecture to user experience, every decision we make is guided
            by quality, security, and simplicity.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-white/5 border border-white/8 rounded-2xl p-7 hover:bg-white/8 transition-colors duration-200 group"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-amber-500/15 rounded-xl mb-5 group-hover:bg-amber-500/25 transition-colors duration-200">
                <i className={`${feature.icon} text-amber-400 text-xl`} />
              </div>
              <h4 className="text-white font-semibold text-base mb-3">{feature.title}</h4>
              <p className="text-white/50 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
